import axios from "axios";
import {
    Observable
} from "rxjs";
import config from "../../config/config";
import Cookie from "cookies-js";


export const Manage_user_service = {
    find_user,
    delete_user,
    getUser,
    updateProfile,
    changePassword,
    getAccessLog,
    sendProblem,
    comparePassword,
    deleteAccountRequest
};

function find_user(formdata) {
    return new Promise((resolve, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc)
        axios.post(config.API_URL + "manage_user/find_user?authorization=" + json_cookie.token, formdata)
        .then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}

function delete_user(user_id) {
    return new Promise((resolve, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc)
        axios.post(config.API_URL + "manage_user/delete_user?authorization=" + json_cookie.token, {user_id : user_id})
        .then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}

function getUser() {
    return new Promise((resolve, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.get(config.API_URL + "admin/getAdminProfile?authorization=" + json_cookie.token).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        });
    })
}

function updateProfile(data) {
    return new Promise((resolve, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "admin/updateProfile?authorization=" + json_cookie.token, data).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        });
    })
}

function changePassword(data) {
    return new Promise((resolve, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "admin/changePassword?authorization=" + json_cookie.token, data).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        });
    })
}

function getAccessLog(filter){
    return new Promise((resolve, reject)=>{
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc)
        axios.post(config.API_URL + "manage_user/get_access_log?authorization=" + json_cookie.token, filter).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        });
    })
}

function sendProblem(formdata) {
    return new Promise((resolve, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc)
        axios.post(config.API_URL + "manage_user/sendProblem?authorization=" + json_cookie.token, formdata)
        .then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}

function comparePassword(user_data) {
    return new Promise((resolve, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc)
        axios.post(config.API_URL + "admin/comparePassword?authorization=" + json_cookie.token, user_data)
        .then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}

function deleteAccountRequest(form) {
    return new Promise((resolve, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc)
        axios.post(config.API_URL + "admin/deleteAccountRequest/?authorization=" + json_cookie.token, form)
        .then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}